
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.172 2.732c0-.375-.146-.729-.412-.994L10.435.412A1.437 1.437 0 009.43 0h-.08v2.813h2.821v-.081z","fill":"#6C6C6C"}}),_c('path',{attrs:{"d":"M8.56 9.673c.09-.272.247-.526.451-.731l3.174-3.162V3.75H8.89a.456.456 0 01-.454-.469V0h-7.03C.63 0 0 .63 0 1.406v13.188C0 15.369.63 16 1.406 16h9.36c.775 0 1.419-.63 1.419-1.406v-3.499l-.515.503a1.864 1.864 0 01-.73.45l-1.49.497-.227.012c-.375 0-.73-.182-.95-.488a1.175 1.175 0 01-.16-1.056l.448-1.34zM2.345 8.437h4.672a.468.468 0 110 .938H2.344a.468.468 0 110-.938zm-.469-1.406c0-.259.21-.468.469-.468h4.672a.468.468 0 110 .937H2.344a.468.468 0 01-.469-.469zm0 3.75c0-.259.21-.469.469-.469h4.672a.468.468 0 110 .938H2.344a.469.469 0 01-.469-.469zm7.016 2.344a.469.469 0 110 .938H6.079a.469.469 0 110-.938H8.89zm-6.547-7.5a.468.468 0 110-.938H8.89a.468.468 0 110 .938H2.344z","fill":"#6C6C6C"}}),_c('path',{attrs:{"d":"M9.41 10.088l-.408 1.223a.234.234 0 00.296.297l1.223-.409-1.111-1.111zM13.05 6.229L9.963 9.316l1.331 1.331 3.087-3.087-1.331-1.331zM15.724 4.884a.938.938 0 00-.664-.261.94.94 0 00-.666.261l-.681.681 1.331 1.331.681-.68a.944.944 0 000-1.332zM15.726 6.216zM15.73 6.213a.213.213 0 01.003-.004l-.004.004zM15.733 6.209c.004-.004.005-.004 0 0z","fill":"#6C6C6C"}})])
          )
        }
      }
    